module.exports = __webpack_public_path__ + "static/media/zastava.07ecb748.png";